import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { TourForm } from '../forms'
import { Dashboard } from '../layouts'
import axios from '../plugins/axios'

const styles = theme => ({
    //
})

class TourNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Tours',
            key: shortid.generate(),
            destinations: []
        }
    }

    componentDidMount = () => {
        this.fetchDestinations()
    }

    fetchDestinations = async () => {
        try {
            const { data } = await axios.get('/destinations', {
                progress: true,
                params: {
                    rowsPerPage: -1,
                    sortBy: 'name',
                    sortOrder: 'asc'
                }
            })

            this.setState({
                key: shortid.generate(),
                destinations: data
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            key,
            title,
            destinations
        } = this.state
        return (
            <Dashboard title={title}>
                <TourForm 
                    key={key}
                    path="tours"
                    method="post"
                    destinations={destinations}
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(TourNew)
